export default {
    company: {},
    companyId: '',
    disabled: false,
    snackbarMessage: '',
    snackbarOpen: false,
    snackbarVariant: 'success',
    activeStep: 0,
    activeSubStep: 0,
    bankingReference: { type: 'banking' },
    supplyCompanyReference: { type: 'supplyCompany' },
    tradeSubcontractorReference: { type: 'tradeSubcontractor' },
    secondBankingFinancialReference: { type: 'secondaryBanking' },
    organizationName: '',
    website: '',
    physicalStreetAddress: '',
    physicalCity: '',
    physicalState: '',
    physicalZipCode: '',
    mailingStreetAddress: '',
    mailingCity: '',
    mailingState: '',
    mailingZipCode: '',
    moreThanMillionRevenue: '',
    physicalAddressSameAsMailing: false,
    legalEntityName: '',
    yearsOfIncorperation: '',
    stateOfIncorperation: '',
    hasBuildersLicense: '',
    buildersLicenseNumber: '',
    licenseRevoked: '',
    revokeReason: '',
    eIN_TAXID: '',
    thirdPartyContractors: [],
    entityOwners: [],
    otherPeople: [],
    constructionExperiences: [],
    residentialExperiences: [],
    usesThirdParty: null,
    buildersLicenses: [],
    sectionComplete: null,
    mobileSectionComplete: null,
    mobileSubSecComplete: null,
    finishModalIsOpen: false,
    loading: true,
    loadingSetupCompany: true,
    entityOwnerPercentages: {},
    entityOwnerPercentComplete: 0,
    entityOwnerBorrowerPercentComplete: 0,
    otherEntityOwners: [],
    additionalPeopleConfirmed: null,
    entitiesOtherPeople: [],
    saveDisabled: false,
};
